// extracted by mini-css-extract-plugin
export default {"thumbnail":"GYXGC","thumbnailBlack":"l2DdJ"};